// The help text behind the (i) next to each onboarding field, in one place so it can be reviewed and edited together.
// Keep each tip to one short sentence or two; state the rule the form actually enforces (formats, lengths, sizes).
// A field points at its tip by name: <FieldTooltip name="companyName" />.

export const FIELD_TIPS = {
  // Company
  companyName: "Legal name exactly as on your trade license. Letters and spaces only, 5–50 characters.",
  tradeLicenseNumber: "Number as printed on your trade license. Letters, numbers, hyphens and dots only.",
  incorporationDate: "Month and year the company was incorporated.",
  companyContactNumber: "UAE mobile number, 9 digits. +971 is already filled in.",
  moaDocument: "Memorandum of Association or certified share register listing all owners. PDF, up to 15 MB.",
  shareholderDocuments: "Emirates ID (front and back) and passport copy of every shareholder. PDF, PNG or JPG, up to 15 MB each.",
  tradeLicenseUpload: "Copy of your trade license. PDF only, up to 15 MB.",

  // Company address
  addressStreet: "Street address (up to 50 characters) and area (up to 20).",
  addressCountry: "Country of this address.",
  addressCity: "City of this address.",
  addressPinCode: "Postal or PO Box code, up to 9 characters. Optional.",
  addressPhone: "9-digit UAE mobile number starting with 5. +971 is already filled in.",
  addressProof: "Document showing this address. PDF only, up to 15 MB.",

  // Authorised signatory
  signatoryName: "Full legal name. Letters and spaces only, 2–50 characters.",
  signatoryDesignation: "This person's role in the company.",
  signatoryContact: "9-digit UAE mobile number starting with 5. +971 is already filled in.",
  signatoryEmail: "This signatory's email address. Use the switch below to reuse your registration email.",
  powerOfAttorney: "Only needed if the primary user is not an authorised signatory in the MOA. PDF, up to 15 MB.",
  signatoryEmiratesId: "Front and back of the Emirates ID. PDF, PNG or JPG.",
  signatoryPassport: "Copy of the passport. PDF, PNG or JPG, up to 15 MB.",

  // Owner (individual)
  ownerFullName: "Owner's full legal name.",
  ownerNationality: "Owner's nationality.",
  ownerDateOfBirth: "Owner's date of birth: day, month and four-digit year.",
  ownerPercentage: "Share of the company this owner holds, from 0.01 to 100. All owners together must total 100%.",
  ownerEmail: "Owner's email address. Optional.",
  ownerPhone: "Owner's phone number. Optional.",
  ownerResident: "Choose Yes if the owner is a UAE citizen or resident.",
  ownerEmiratesId: "Front and back of the Emirates ID.",
  ownerPassport: "Front and back of the passport.",

  // Owner (company)
  ownerCompanyName: "Legal name of the owning company, as on its trade license.",
  ownerCompanyAddress: "Registered address of the owning company.",
  ownerCompanyCountry: "Country where the owning company is registered.",
  ownerCompanyCity: "City of the owning company's address.",
  ownerCompanyPincode: "Postal code of the owning company's address.",
  ownerCompanyIncorporationDate: "Date the owning company was incorporated.",
  ownerCompanyMoa: "MOA or certified share register of the owning company. PDF, up to 15 MB.",
  ownerCompanyTradeLicense: "Trade license of the owning company. PDF, PNG or JPG, up to 5 MB.",

  // VAT
  vatNumber: "15-digit VAT registration number from your VAT certificate.",
  vatCertificate: "Your VAT registration certificate. PDF only, up to 15 MB.",

  // Bank account
  bankAccountNumber: "Account number, 6–16 digits.",
  bankIban: "UAE IBAN: 23 characters, AE followed by 21 digits.",
  bankCurrency: "Currency this account is held in.",
  bankName: "Bank where the account is held.",
  bankBranch: "Branch name, at least 3 characters.",
  bankSwift: "The bank's SWIFT code: 8–11 letters or numbers.",
};
